export default {
  permissions: [],
  meta: {},
  permission: {}
};